import { useState } from 'react';
import TextField from '@mui/material/TextField';
import { webSavedSearchNameCharCountLimit } from '@Components/Utilities/SandhillsConstants';


const FacetedSearchHybridItem = (props) => {
    const [showEdit, setShowEdit] = useState(false);
    const [name, setName] = useState(props.Name);

    const toggleEdit = (e) => {
        if (e) {
            e.preventDefault();
        }
        setShowEdit(!showEdit);
        props.handleEdit(name);
    };

    const textChange = (e) => {
        setName(e);
    };
    const onKeyPress = (e) => {
        if (e.key === 'Enter') {
            props.handleEdit(name);
            toggleEdit();
        }
    };
    const closeEdit = (e) => {
        e.preventDefault();
        setShowEdit(false);
        props.handleEdit();
    }


    return (
        <div className={showEdit ? 'hybrid-content-edit' : 'hybrid-content'}>
            {showEdit ?
                <TextField variant="standard"
                    className='hybrid-text-box'
                    placeholder={props.Name}
                    label={props.Name}
                    sx={{ 'width': '80%' }}
                    value={name}
                    InputLabelProps={{ className: 'visually-hidden', shrink: true }}
                    onChange={(e) => textChange(props.truncateText(e.target.value, webSavedSearchNameCharCountLimit))}
                    autoFocus={true}
                    onKeyPress={onKeyPress}
                    onFocus={e => { e.target.select(); }} />
                :
                <span className={props.disabled ? 'option-name disabled' : 'option-name'}><div className='view-text' tabIndex='0'>{props.Name}</div></span>
            }
            <div className={props.disabled ? 'button-icons disabled' : 'button-icons'}>
                <i role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); props.disabled ? null : toggleEdit(props.WatchlistID); } }} onClick={(e) => props.disabled ? null : toggleEdit(props.WatchlistID)} className={showEdit ? 'fas fa-save' : "fas fa-pencil-alt"} title={showEdit ? translator.translate('sandhills.photosvideos.savechanges') : translator.translate('sandhills.edit')} />
                <i role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); showEdit ? closeEdit(e) : props.removeWatchlist(props.Value, e); } }} onClick={(e) => props.disabled ? null : showEdit ? closeEdit(e) : props.removeWatchlist(props.Value, e)} className={showEdit ? 'fas fa-x' : 'fas fa-trash'} title={showEdit ? translator.translate('sandhills.closepage') : translator.translate('sandhills.delete')} />
            </div>
        </div>
    )

}

export default FacetedSearchHybridItem
